// Pure data, no imports, on purpose: vite.config.ts reads this list at build
// time to write the first-visit picker into index.html (see bootPicker in
// vite.config.ts), and a config file cannot load anything that touches
// Supabase or the browser. lib/useFilterGroup re-exports it, so the app's
// imports are unchanged.

export interface Interest {
  /** A slug in lyh_filter_groups. */
  slug: string
  label: string
  desc: string
}

/**
 * The interests offered on the first visit, in the order they're shown: left to
 * right, top to bottom (Andrew, 7/28).
 *
 * The labels here win over the ones on the rows. A group's own label is written
 * for whoever it was made for (some are titled after the Reddit thread they
 * answer), where these are the six standing interests.
 *
 * "Arts & Crafts" is spelled the way the category is spelled everywhere else
 * now, so someone who picks it here meets the same words in the drawer later
 * (see lib/hostLabels).
 */
export const INTERESTS: Interest[] = [
  { slug: 'family-friendly', label: 'Family friendly', desc: 'storytimes, LEGO clubs, kid stuff' },
  { slug: 'shows', label: 'Live music & shows', desc: 'concerts, theater, comedy' },
  { slug: 'outdoors', label: 'Outdoors', desc: 'trails, paddling, markets' },
  { slug: 'games', label: 'Games & trivia', desc: 'tabletop, trivia, bingo, mahjong' },
  { slug: 'arts-crafts', label: 'Arts & Crafts', desc: 'paint nights, pottery, maker classes' },
  { slug: 'date-night', label: 'Date night', desc: 'music, wine, comedy' },
]
